"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.spaces = exports.breakpoints = void 0;
var breakpoints = ['600px', '900px', '1200px', '1800px'];
exports.breakpoints = breakpoints;
var spaces = ['8px', '16px', '32px', '64px'];
exports.spaces = spaces;
var _default = {
  breakpoints: breakpoints,
  spaces: spaces
};
exports.default = _default;